// ID-12903: shared owns the eLinx flow (shared/eLinx) and its provider (composed into SharedProviders).
// Shared's useELinxConnect is a pure pass-through whose open() needs country/clientAccountsEnabled; this
// host adapter binds those from useClientData behind a custom open(values, accountID) so call sites don't
// have to know about them.
import { useELinxConnect as useSharedELinxConnect, ELinxConnectRequest } from 'shared/eLinx';
import { useClientData } from '@/providers/ClientData.provider';

export default function useELinxConnect() {
  const { open } = useSharedELinxConnect();

  const {
    response: { clientAccountsEnabled, Country },
  } = useClientData();

  return {
    open: (values: ELinxConnectRequest, accountID?: string) => open(values, Country, clientAccountsEnabled, accountID),
  };
}
